// extracted by mini-css-extract-plugin
export default {"root":"ChatModal_root__AfiYZ","body":"ChatModal_body__MzQUo"};